"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AbstractDecorator = /** @class */ (function () {
    function AbstractDecorator(renderer) {
        this.renderer = renderer;
    }
    AbstractDecorator.prototype.appendContent = function (element) {
        this.renderer.appendContent(element);
    };
    AbstractDecorator.prototype.appendSuggest = function (element) {
        this.renderer.appendSuggest(element);
    };
    AbstractDecorator.prototype.init = function (channelId) {
        this.renderer.init(channelId);
        this.channelId = channelId;
    };
    AbstractDecorator.prototype.render = function (message, containerType) {
        return this.renderer.render(message, containerType);
    };
    return AbstractDecorator;
}());
exports.AbstractDecorator = AbstractDecorator;
